<template>
    <div class="main_bd">
        <div class="head_title">Minipass Merchants List</div>
        <a-menu v-model="current" mode="horizontal">
            <a-menu-item key="matched">Matched </a-menu-item>
            <a-menu-item key="not_matched"> Not Matched  </a-menu-item>
        </a-menu>
        <div style="margin-top: 20px;">
            <div style="margin-bottom: 10px;">
                <a-input v-model="search" @keyup="doKeyUp" placeholder="Search" style="width: 200px; margin-right: 10px;"></a-input>
                <a-button @click="get_minipass_merchant_list">Search</a-button>
                <div style="display: inline-block; float: right;" v-if="current == 'matched'">
                    <span style="padding-right: 10px;">Sort By</span>
                    <a-select @change="get_minipass_merchant_list" v-model="sort_by" style="width: 230px; margin-right: 10px;">
                        <a-select-option value="id">Default</a-select-option>
                        <a-select-option value="waitlist_count_month">Waitlist count (By month)</a-select-option>
                        <a-select-option value="reserve_count_month">Reserve count (By month)</a-select-option>
                        <a-select-option value="popular_count_total">Popular count (By month)</a-select-option>
                    </a-select>
                </div>
                <a-button @click="onShowAddLayer" style="float: right;" type="primary" v-if="current == 'not_matched'">Add Merchant</a-button>
            </div>
            <div v-if="current == 'matched'">
                <a-table :pagination="false" :rowKey="data => data.sid" :columns="columns" :data-source="merchant_list" >
                    <template slot="ai_status" slot-scope="text, data">
                        <a-switch v-model="data.ai_enable" @change="update_status(data, 'ai', $event)" />
                    </template>
                    <template slot="waitwise_status" slot-scope="text, data">
                        <a-switch v-model="data.waitwise_enable" @change="update_status(data, 'waitwise', $event)" />
                    </template>
                    <template slot="autojoin_status" slot-scope="text, data">
                        <a-switch v-model="data.autojoin_enable" @change="update_status(data, 'autojoin', $event)" />
                        <span v-if="data.autojoin_enable == 1">
                            <a-input type="text" v-model="data.autojoin_limit" style="width: 50px; margin-left: 10px;" />
                            <a-button type="primary" style="margin-left: 10px;" @click="update_status(data, 'autojoin', $event)">Save</a-button>
                        </span>
                    </template>
                    <template slot="display_status" slot-scope="text, data">
                        <a-switch v-model="data.display_status_enable" @change="changeDisplayStatus(data, $event)" />
                    </template>
                </a-table>
                <a-pagination style="margin-top: 5px;" @change="turnPage" :pageSize="20" v-model="cur_page" :total="total_count"
                    show-less-items />
            </div>
            <div v-if="current == 'not_matched'">
                <a-table :pagination="false" :rowKey="data => data.sid" :columns="not_matched_columns" :data-source="merchant_list" >
                    <template slot="display_status" slot-scope="text, data">
                        <a-switch v-model="data.display_status_enable" @change="changeDisplayStatus(data, $event)" />
                    </template>
                    <template slot="action" slot-scope="text, data">
                        <a-button type="info" @click="showMerchantInfo(data)" style="margin-left: 10px;">Show info</a-button>
                        <a-button type="primary" @click="showEditPicLayer(data)" style="margin-left: 10px;">
                            {{ data.slogo && data.feature_image ? 'Edit Picture' : 'Upload Picture' }}
                        </a-button>
                        <a-button type="default" @click="doDelete(data.sid)" style="margin-left: 10px;">Delete</a-button>
                    </template>
                </a-table>
                <a-pagination style="margin-top: 5px;" @change="turnPage" :pageSize="20" v-model="cur_page" :total="total_count"
                    show-less-items />
            </div>
        </div>
        <a-drawer
            title="Add merchant"
            :width="475"
            placement="right"
            :closable="false"
            :visible="show_add_layer"
            :after-visible-change="afterVisibleChange"
            @close="onHideAddLayer"
        >
            <template #extra>
                <a-button type="primary" @click="doAddMerchant" :loading="is_adding">Submit</a-button>
            </template>
            <div style="text-align: center; margin: 0px auto 10px;">
                <a-radio-group v-model="add_method" :options="method_options" />
            </div>
            <div v-if="add_method == 'single'">
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Place ID *</span>
                    <a-input :disabled="is_displaying" style="display: inline-block; width: auto;" v-model="add_placeid" placeholder="google place id" />
                    <a-button v-if="!is_displaying" type="primary" :loading="is_explaining" @click="doExplainPlaceid" style="margin-left: 10px;">Explain</a-button>
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Name</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_sname" placeholder="merchant name" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Phone</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_stel" placeholder="merchant tel" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Timezone</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_timezone" placeholder="merchant timezone" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Country</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_country" placeholder="merchant country" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Region</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_region" placeholder="merchant region" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">State</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_state" placeholder="merchant state" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Locality</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_locality" placeholder="merchant locality" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Street address</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_street_address" placeholder="merchant street address" />
                </div>
                <div style="margin-top: 10px;">
                    <span style="width: 30%; display: inline-block;">Postal code</span>
                    <a-input :disabled="true" style="display: inline-block; width: auto;" v-model="add_postal_code" placeholder="merchant postal code" />
                </div>
            </div>
            <div v-else style="text-align: center;">
                <a-textarea style="width: 300px; display: inline-block;" :rows="20" v-model="add_placeids" placeholder="Place ID list, one per line, can be copied from excel" />
            </div>
            <div
                :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1,
                }"
            >
                <a-button :style="{ marginRight: '8px' }" @click="onHideAddLayer">
                    Cancel
                </a-button>
                <a-button v-if="!is_displaying" type="primary" @click="doAddMerchant" :loading="is_adding">
                    Submit
                </a-button>
            </div>
        </a-drawer>
        <a-drawer
            title="Update merchant picture"
            :width="475"
            placement="right"
            :closable="false"
            :visible="show_edit_pic_layer"
            @close="hideEditPicLayer"
        >
            <div style="margin-top: 10px;">
                <span style="width: 30%; display: inline-block;">Logo</span>
                <upload-img :cutwidth="100" :cutheight="100" @upload="upload_logo_image" :photo="edit_store_logo"></upload-img>
            </div>
            <div style="margin-top: 10px;">
                <span style="width: 30%; display: inline-block;">Cover Picture</span>
                <upload-img :cutwidth="400" :cutheight="300" @upload="upload_display_image" :photo="edit_store_display_image"></upload-img>
            </div>
            <div
                :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1,
                }"
            >
                <a-button :style="{ marginRight: '8px' }" @click="hideEditPicLayer">
                    Hide
                </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueSweetalert2 from "vue-sweetalert2";
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
    import UploadImg from '../../components/UploadImg.vue';

    Vue.use(VueSweetalert2);

    const columns = [
        {
            title: "Sid",
            dataIndex: "sid",
            width: 320
        },
        {
            title: "Merchant Name",
            dataIndex: "sname"
        },
        {
            title: "Timezone",
            dataIndex: "timezone"
        },
        // {
        //     title: "AI Agents Status",
        //     dataIndex: "ai_enable",
        //     scopedSlots: { customRender: 'ai_status' }
        // },
        {
            title: "Display In App",
            dataIndex: "display_status_enable",
            scopedSlots: { customRender: 'display_status' }
        },
        {
            title: "Waitwise",
            dataIndex: "waitwise_enable",
            scopedSlots: { customRender: 'waitwise_status' }
        },
        {
            title: "Autojoin",
            dataIndex: "autojoin_enable",
            scopedSlots: { customRender: 'autojoin_status' }
        }
    ];

    const not_matched_columns = [
        {
            title: "Sid",
            dataIndex: "sid",
            width: 320
        },
        {
            title: "Merchant Name",
            dataIndex: "sname"
        },
        {
            title: "Phone",
            dataIndex: "stel"
        },
        {
            title: "Timezone",
            dataIndex: "timezone"
        },
        {
            title: "Display Status",
            dataIndex: "display_status_enable",
            scopedSlots: { customRender: 'display_status' }
        },
        {
            title: "Action",
            dataIndex: "id",
            scopedSlots: { customRender: 'action' }
        }
    ];

    export default {
        name: 'minipass_merchant_list',
        components: { UploadImg },
        data() {
            return {
                search: '',
                sid: window.localStorage.getItem('sid'),
                uname: window.localStorage.getItem('uname'),
                columns,
                not_matched_columns,
                merchant_list: [],
                cur_page: 1,
                total_page: 0,
                total_count: 0,
                sort_by: 'id',

                current: ['matched'],
                show_add_layer: false,
                is_adding: false,
                is_explaining: false,
                add_sname: '',
                add_stel: '',
                add_timezone: 'America/New_York',
                add_placeid: '',
                add_locality: '',
                add_state: '',
                add_country: '',
                add_region: '',
                add_street_address: '',
                add_postal_code: '',
                add_longitude: '',
                add_latitude: '',

                show_edit_pic_layer: false,
                edit_store: null,
                edit_store_logo: '',
                edit_store_display_image: '',

                add_method: 'single',
                method_options: [
                    { label: 'Single', value: 'single' },
                    { label: 'Batch', value: 'batch' },
                ],
                add_placeids: '',
            };
        },
        beforeMount() {},
        async created() {
            this.get_minipass_merchant_list();
        },
        watch: {
            current() {
                this.get_minipass_merchant_list();
            }
        },
        mounted() {
        },
        computed: {
            ...mapGetters({}),
            ...mapState({})
        },
        methods: {
            ...mapActions({
                getMerchantList: 'merchant/getMerchantList',
                updateMerchantStatus: 'merchant/updateMerchantStatus',
                getPlaceidData: 'merchant/getPlaceidData',
                createMerchant: 'merchant/createMerchant',
                updateMerchant: 'merchant/updateMerchant',
                deleteMerchant: 'merchant/deleteMerchant',
                batchCreateMerchants: 'merchant/batchCreateMerchants',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            turnPage(e) {
                this.get_minipass_merchant_list();
            },
            async update_status(data, type, evt) {
                if (type == 'autojoin') {
                    if (data.waitwise_enable == 0) {
                        this.$message.error('Please enable Waitwise first');
                        data.autojoin_enable = 0;
                        return;
                    }
                }

                let res = await this.updateMerchantStatus({
                    sid: data.sid,
                    enable: evt ? 1 : 0,
                    type: type,
                    autojoin_limit: data.autojoin_limit,
                });

                if (res.code == 100000) {
                    this.get_minipass_merchant_list();
                    this.$message.success('Updated successfully');
                }
            },
            async get_minipass_merchant_list() {
                let { list, total_count, total_page } = await this.getMerchantList({
                    search: encodeURIComponent(this.search),
                    page: this.cur_page,
                    sort_by: this.sort_by,
                    matched: this.current == 'matched' ? 1 : 0
                });

                this.merchant_list = list;
                this.total_page = total_page;
                this.total_count = total_count;
            },
            doKeyUp(e) {
                if (e.keyCode === 13) {
                    this.get_minipass_merchant_list();
                }
            },
            afterVisibleChange(val) {
                console.log('visible', val);
            },
            onHideAddLayer() {
                this.resetAddData();
            },
            onShowAddLayer() {
                this.show_add_layer = true;
            },
            async doBatchAddMerchants() {
                if (!this.add_placeids) {
                    this.$message.error('Please input place ids');
                    return;
                }

                if (this.is_adding) {
                    this.$message.error('Please wait for the last request to finish');
                    return;
                }

                this.is_adding = true;

                let place_ids = this.add_placeids.split('\n').filter(item => item);
                let post_data = {
                    place_ids: place_ids.join(','),
                };

                let count = place_ids.length;
                this.$message.info('Please wait for the request to finish, it may take ' + count + ' seconds');

                let res = await this.batchCreateMerchants(post_data);

                this.is_adding = false;

                if (res.code != 100000) {
                    this.$message.error(res.msg || 'system error');
                    return;
                } else {
                    this.$message.success(res.msg);
                }

                this.get_minipass_merchant_list();
                this.resetAddData();
            },
            async doAddMerchant() {
                if (this.add_method == 'batch') {
                    this.doBatchAddMerchants();
                    return;
                }

                if (!this.add_placeid) {
                    this.$message.error('Please input place id');
                    return;
                }

                if (!this.add_sname) {
                    this.$message.error('Please explain place id first');
                    return;
                }

                if (this.is_adding) {
                    this.$message.error('Please wait for the last request to finish');
                    return;
                }

                this.is_adding = true;

                let post_data = {
                    add_sname: this.add_sname,
                    add_timezone: this.add_timezone,
                    add_stel: this.add_stel,
                    add_locality: this.add_locality,
                    add_state: this.add_state,
                    add_country: this.add_country,
                    add_region: this.add_region,
                    add_street_address: this.add_street_address,
                    add_postal_code: this.add_postal_code,
                    add_longitude: this.add_longitude,
                    add_latitude: this.add_latitude,
                    add_placeid: this.add_placeid,
                };

                let res = await this.createMerchant(post_data);

                this.is_adding = false;

                if (res.code != 100000) {
                    this.$message.error(res.msg || 'system error');
                    return;
                }

                this.get_minipass_merchant_list();
                this.resetAddData();
            },
            async doExplainPlaceid() {
                if (!this.add_placeid) {
                    this.$message.error('Please input place id');
                    return;
                }

                this.is_explaining = true;

                let res = await this.getPlaceidData({
                    placeid: this.add_placeid
                });

                if (res.code != 100000) {
                    this.$message.error(res.msg || 'system error');
                    this.is_explaining = false;
                    return;
                }

                let place_info = res.data.info;
                
                this.add_sname = place_info.sname || '';
                this.add_timezone = place_info.timezone || '';
                this.add_stel = place_info.phone || '';
                this.add_locality = place_info.locality || '';
                this.add_state = place_info.state || '';
                this.add_country = place_info.country || '';
                this.add_region = place_info.region || '';
                this.add_street_address = place_info.street_address || '';
                this.add_postal_code = place_info.postal_code || '';
                this.add_longitude = place_info.longitude || '';
                this.add_latitude = place_info.latitude || '';
                
                this.is_explaining = false;
            },
            resetAddData() {
                this.is_displaying = false;
                this.show_add_layer = false;
                this.add_sname = '';
                this.add_timezone = '';
                this.add_stel = '';
                this.add_locality = '';
                this.add_state = '';
                this.add_country = '';
                this.add_region = '';
                this.add_street_address = '';
                this.add_postal_code = '';
                this.add_longitude = '';
                this.add_latitude = '';
                this.add_placeid = '';

                this.add_method = 'single';
                this.add_placeids = '';
            },
            async doDelete(sid) {
                let that = this;

                this.$confirm({
                    title: 'Are you sure you want to delete?',
                    content: 'Unable to recover after deletion',
                    okText: 'Sure',
                    okType: 'danger',
                    cancelText: 'cancel',
                    onOk: async () => {
                        let res = await that.deleteMerchant({ sid });

                        if (res.code != 100000) {
                            that.$message.error(res.msg || 'system error');

                            return;
                        }

                        that.$message.success('Success');
                        that.get_minipass_merchant_list();
                    },
                    onCancel: async () => {},
                });
            },
            showEditPicLayer(data) {
                this.show_edit_pic_layer = true;
                this.edit_store = data;

                if (data.slogo) {
                    this.edit_store_logo = data.slogo;
                }

                if (data.feature_image) {
                    this.edit_store_display_image = data.feature_image;
                }
            },
            hideEditPicLayer() {
                this.show_edit_pic_layer = false;
                this.edit_store = null;
                this.edit_store_logo = '';
                this.edit_store_display_image = '';
            },
            async upload_logo_image(url) {
                this.edit_store_logo = url;

                if (!this.edit_store.sid) {
                    return;
                }

                let res = await this.updateMerchant({
                    sid: this.edit_store.sid,
                    type: 'slogo',
                    val: url,
                });

                if (res.code != 100000) {
                    this.$message.error(res.msg || 'system error');
                    return;
                }
                
                this.$message.success('Upload successfully!');
            },
            async upload_display_image(url) {
                this.edit_store_display_image = url;

                if (!this.edit_store.sid) {
                    return;
                }

                let res = await this.updateMerchant({
                    sid: this.edit_store.sid,
                    type: 'feature_image',
                    val: url,
                });

                if (res.code != 100000) {
                    this.$message.error(res.msg || 'system error');
                    return;
                }
                
                this.$message.success('Upload successfully!');
            },
            async changeDisplayStatus(data, evt) {
                let res = await this.updateMerchant({
                    sid: data.sid,
                    val: evt ? 1 : 0,
                    type: 'display_status_enable',
                });

                if (res.code == 100000) {
                    this.get_minipass_merchant_list();
                    this.$message.success('Updated successfully');
                }
            },
            showMerchantInfo(data) {
                this.add_placeid = data.place_id;
                this.add_sname = data.sname;
                this.add_timezone = data.timezone;
                this.add_stel = data.stel;
                this.add_locality = data.locality;
                this.add_state = data.state;
                this.add_country = data.country;
                this.add_region = data.region;
                this.add_street_address = data.street_address;
                this.add_postal_code = data.postal_code;

                this.show_add_layer = true;
                this.is_displaying = true;
            }
        }
    };
</script>

<style>
</style>
